<div class="container-fluid maap-root-container">
  <app-header [showWitness]="true"></app-header>
  <app-sidebar></app-sidebar>
  <div style="margin-top: 60px; margin-left: 80px;">
    <router-outlet></router-outlet>
  </div>
 </div>
 <p-dialog  [(visible)]="showAddLocationDialog" [style]="{width: '90vw'}">
  <p-header>
Add New Stock Area
  </p-header>
  <app-add-location></app-add-location>
</p-dialog>

<p-dialog  [(visible)]="showAddUserDialog" [style]="{width: '90vw'}">
  <p-header>
Add New User
  </p-header>
  <app-add-user></app-add-user>
</p-dialog>
